/**
 * Quick Stat Card Component
 * Displays a single metric with optional change indicator
 */
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function QuickStatCard({ label, value, change, icon: Icon, color = 'blue', tooltip }) {
  const colorClasses = {
    green: 'bg-green-500/10 text-green-600 dark:text-green-400',
    blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
    red: 'bg-red-500/10 text-red-600 dark:text-red-400',
    purple: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
    orange: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
    yellow: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
  };

  const iconColorClasses = {
    green: 'text-green-500',
    blue: 'text-blue-500',
    red: 'text-red-500',
    purple: 'text-purple-500',
    orange: 'text-orange-500',
    yellow: 'text-yellow-500',
  };

  return (
    <div 
      className="bg-card rounded-xl p-4 border border-border"
      title={tooltip}
    >
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorClasses[color]}`}>
          <Icon className={`w-5 h-5 ${iconColorClasses[color]}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-muted-foreground truncate">{label}</p>
          <div className="flex items-center gap-2">
            <p className="text-lg font-bold text-foreground">{value}</p>
            {typeof change === 'number' && (
              <span className={`flex items-center text-xs font-medium ${
                change >= 0 ? 'text-green-600' : 'text-red-600'
              }`}>
                {change >= 0 ? (
                  <TrendingUp className="w-3 h-3 mr-0.5" />
                ) : (
                  <TrendingDown className="w-3 h-3 mr-0.5" />
                )}
                {Math.abs(change).toFixed(1)}%
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
